import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";

// Dynamic import core to control initialization order
import("@koolay-platform/core").then(({ initSupabase, initErrorLogger, installGlobalErrorHandlers, setKoolayTurnstileSiteKey }) => {
  initSupabase(
    import.meta.env.VITE_SUPABASE_URL,
    import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY,
    import.meta.env.VITE_SUPABASE_ANON_KEY
  );
  // Library-mode core's import.meta.env was substituted at build time, so the
  // TurnstileWidget can't read VITE_TURNSTILE_SITE_KEY from inside. Push it
  // across via the consumer-side env var, otherwise the SuperAdminLogin
  // captcha renders "no site key" and blocks every login attempt.
  setKoolayTurnstileSiteKey(import.meta.env.VITE_TURNSTILE_SITE_KEY);
  // Error tracking — in-house logger, zero third-party data leak
  initErrorLogger({
    endpoint: `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/koolay-error-logger`,
    anonKey: import.meta.env.VITE_SUPABASE_ANON_KEY,
    environment: import.meta.env.PROD ? "crm-prod" : "crm-dev",
    release: import.meta.env.VITE_KOOLAY_RELEASE,
  });
  installGlobalErrorHandlers();
  return import("./App");
}).then(({ default: App }) => {
  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
});
